module.exports = (data = {}, promises)=>(
    new Promise((resolve, reject)=>{
        const promiseKeys = Object.keys(promises)
        Promise.all(Object.values(promises)).then((responses)=>{
            for(let [i,response] of responses.entries()){
                data[promiseKeys[i]] = response
            }
            resolve(data)
        }).catch((error)=>{
            reject(error)
        })
    })
)

/* Example
     pile({}, {
          accounts: Accounts.fetch(),
          users: Users.fetch(),
          patients: Patients.fetch()
     }).then((data)=>{
        // merge data here 
        // then
      
     })
     // Or
     pile({}, {
          accounts: Accounts.fetch()
    }).then((data)=>{
      return pile(data, users: Users.fetch({accountID: data.account.id}))
    }).then(data)=>{
          return pile(data, {patients: Patients.fetch({userID: user.id})})
    }).then((data)=>{
       console.log(data.accounts)
       console.log(data.users)
       console.log(data.patients)
     })
 */


// WEBPACK FOOTER //
// ./lib/helpers/pile.js